import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Context } from "../../../context/userContext";
import Avatar from './../Avatar/Avatar';
import { baseUrl } from "../../../config/config";
import "./chatitem.scss";

export default function ChatItem ({usersId, chatRoomId}){
    const navigate = useNavigate();
    const {userInfo} = useContext(Context);
    const [receiver, setReciever] = useState(null);
    // const [lastMessage, setLastMessage] = useState(null);

    const fetchUserInfo = (userId) => {
        axios.get(`${baseUrl}/chat/${chatRoomId}`)
        .then(res => {
          if(res.data) {
            const destinataire = res.data.users.find((user) => user.id !== userInfo?.id)
                if(destinataire !== userInfo){
                    setReciever(destinataire)
                }
          }
        })
        .catch(err => {
          console.log(err);
        })
    }
    
    useEffect(() => {
      fetchUserInfo(usersId)
    }, [usersId])
    
    return (
      <div
        className={`chatlist__item`}
        onClick={() => navigate(`/room/${chatRoomId}`)}
      >
        <Avatar
          fiantso={receiver?.fiantso}
          useremail={receiver?.email}
          chatRoomId={chatRoomId}
        />
      </div>
    );
}
